import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import http from '../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../common/utils/uploadFileUtil'

export default {
  data () {
    return {
      info: null,
      detailsForm: {
        companyName: '',
        address: '',
        reservationPhone: '',
        rescuePhone: '',
        codeToFileIds: {
          logo: []
        }, //图片          
      },
    }
  },
  methods: {
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    getCompanyInfo () {
      http.get(API_BASE_URL + '/api/sys/prop/typeId/100/propName/companyInfo').then(
        res => {
          const id = res.data.data.id
          const info = res.data.data.value
          const codeToFileIds = info.codeToFileIds || {}
          codeToFileIds.logo = codeToFileIds.logo || []
          this.id = id
          this.detailsForm = {
            companyName: info.companyName,
            address: info.address,
            reservationPhone: info.reservationPhone,
            rescuePhone: info.rescuePhone,
            codeToFileIds: codeToFileIds
          }

          if (codeToFileIds && codeToFileIds.logo) {
            this.assessImageList2 = []
            let fileIds = codeToFileIds.logo
            this.fileIdList = fileIds
            fileIds.forEach((item, index) => {
              this.assessImageList2.push({
                name: item,
                uid: index,
                url: `${DOWNLOAD_FILE}${item}`
              })
            })
          }
        }
      )
    },
  },
  mounted () {
    document.title = '预约详情'
    this.getCompanyInfo()
    this.info = this.$route.query.info
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/views/consumption-info.js